import { createAction } from 'redux-actions';

import {
	GdsService_OrderAdditionalServiceGdsServiceBaseInfo_Fragment as Service,
	CheckinPassengerFragment,
	CheckinOrderFragment
} from '@websky/graphql';
import { ModifiedService } from '../../types';
import { ServicePayload } from '../../../../Checkout/store/selectedServices/actions';

export const SET_SERVICE = 'SET_SERVICE';
export const ADD_SERVICE = 'ADD_SERVICE';
export const REMOVE_SERVICE = 'REMOVE_SERVICE';
export const SET_SELECTED_SERVICES = 'SET_SELECTED_SERVICES';
export const SAVE_SERVICES = 'SAVE_SERVICES';
export const CLEAR_SERVICE = 'CLEAR_SERVICE';
export const EQUALIZE_PASSENGER_BAGGAGE = 'EQUALIZE_PASSENGER_BAGGAGE';
export const REPLACE_SERVICE = 'REPLACE_SERVICE';
export const SET_SERVICES_WITH_SAVE = 'SET_SERVICES_WITH_SAVE';

export interface EqualizePassengerBaggagePayload {
	passengerId: string;
	baggageList: Set<string>;
	segmentsList: Set<string>;
}

export interface ReplaceServicePayload {
	passengerId: string;
	segmentsList: Set<string>;
	oldService: Service;
	newService: Service;
}

export type SaveServicesMeta = { resolve?: (order: CheckinOrderFragment) => void };

export const setServices = createAction<ServicePayload[]>(SET_SERVICE);
export const addService = createAction<ModifiedService>(ADD_SERVICE);
export const removeService = createAction<ModifiedService>(REMOVE_SERVICE);
export const clearService = createAction<ModifiedService>(CLEAR_SERVICE);
export const setSelectedServices = createAction<CheckinPassengerFragment[]>(SET_SELECTED_SERVICES);
export const saveServices = createAction<void, SaveServicesMeta>(
	SAVE_SERVICES,
	() => undefined,
	(_, meta: SaveServicesMeta) => meta
);
export const setServicesWithSave = createAction<ServicePayload[]>(SET_SERVICES_WITH_SAVE);
export const replaceService = createAction<ReplaceServicePayload>(REPLACE_SERVICE);
export const equalizePassengerBaggage = createAction<EqualizePassengerBaggagePayload>(EQUALIZE_PASSENGER_BAGGAGE);
